<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-align:center; padding-top:150px;"><strong><em>Breathe on me breath of God,</em></strong></p>
<p style="text-align:center; padding-top:15px;"><strong><em>Fill me with life anew</em></strong></p>
<p style="text-align:center; padding-top:15px;"><strong><em>That I may love what Thou dost love,</em></strong></p>
<p style="text-align:center; padding-top:15px;"><strong><em>And do what Thou wouldst do.</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2c6de844